import { render, staticRenderFns } from "./Justification.vue?vue&type=template&id=24022512"
import script from "./Justification.vue?vue&type=script&lang=js"
export * from "./Justification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports